import { render } from "./ListarCollegiados.vue?vue&type=template&id=55d0c605&scoped=true"
import script from "./ListarCollegiados.vue?vue&type=script&lang=js"
export * from "./ListarCollegiados.vue?vue&type=script&lang=js"

import "./ListarCollegiados.vue?vue&type=style&index=0&id=55d0c605&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d0c605"]])

export default __exports__